import React from "react";
import { Route, Switch } from "react-router";
import { withRouter } from "react-router-dom";
import ManagementDashboard from "./Components/ManagementDashboard";
import { ConnectedRouter } from 'connected-react-router'
import { history } from './config/configureStore'

import Users from "./Components/User";
import Setting from "./Components/Configuration/Setting";
import EventLogs from "./Components/Configuration/EventLogs"
import SystemMaster from "./Components/SystemMaster";
import OperationDashboard from "./Components/OperationDashboard";
import FrameDashboard from "./Components/FrameDashboard";
import LocationMaster from "./Components/LocationMaster";
import HazardPoints from "./Components/HazardPoints";
import ImpactHazard from "./Components/ImpactHazard";
import RouteMaster from "./Components/RouteMaster";
import RouteSuggestion from "./Components/RouteSuggestion";
import Tracking from "./Components/Tracking";
import DistanceMatrixMaster from "./Components/DistanceMatrixMaster";
import { setSidebarVisibility } from './reducers/ui';

// Hides the sidebar on mount instead of dispatching during render.
// Dispatching inside a Route's `component`/`render` callback runs during the
// render phase and triggers React's "Cannot update during an existing state
// transition" warning; doing it in componentDidMount is the supported timing.
class RouteView extends React.Component {
  componentDidMount() {
    const { dispatch, hideSidebar = true } = this.props;
    if (hideSidebar) {
      dispatch(setSidebarVisibility(false));
    }
  }
  render() {
    return this.props.children;
  }
}

const ContentRoutes = (props) => {
  const {dispatch} = props;
  return(
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/management_dash" render={() => <ManagementDashboard name="ManagementDashboard" />} />
        <Route
          path="/operation_dash"
          render={() => (
            // Force closing sidebar to have more main content space for Operation view
            <RouteView dispatch={dispatch}>
              <OperationDashboard name="OperationDashboard" />
            </RouteView>
          )}
        />
        <Route
          path="/frame_dash"
          render={() => (
            // Force closing sidebar to have more main content space for Frame view
            <RouteView dispatch={dispatch}>
              <FrameDashboard name="FrameDashboard" />
            </RouteView>
          )}
        />
        <Route
          path="/route_suggestion/:jobDashboardId"
          render={() => (
            <RouteView dispatch={dispatch}>
              <RouteSuggestion name="Route Suggestion" />
            </RouteView>
          )}
        />
        <Route
          path="/tracking/:jobDashboardId"
          render={() => (
            <RouteView dispatch={dispatch}>
              <Tracking name="Route Suggestion" />
            </RouteView>
          )}
        />
        <Route
          path="/location_master"
          render={() => (
            <RouteView dispatch={dispatch}>
              <LocationMaster name="Location Master" />
            </RouteView>
          )}
        />
        <Route
          path="/route_master"
          render={() => (
            <RouteView dispatch={dispatch}>
              <RouteMaster name="Route Master" />
            </RouteView>
          )}
        />
        <Route
          path="/hazard_point"
          render={() => (
            <RouteView dispatch={dispatch}>
              <HazardPoints name="Hazard Points" />
            </RouteView>
          )}
        />
        <Route
          path="/impact_hazard/:routeCode?/:runSeq?"
          render={() => (
            <RouteView dispatch={dispatch}>
              <ImpactHazard name="Impact Hazard" />
            </RouteView>
          )}
        />
        <Route
          path="/distance_matrix_master"
          render={() => (
            <RouteView dispatch={dispatch}>
              <DistanceMatrixMaster name="Distance Matrix Master" />
            </RouteView>
          )}
        />
        <Route
          path="/users"
          render={() => (
            <RouteView dispatch={dispatch}>
              <Users name="Users" />
            </RouteView>
          )} />
        <Route
          path="/settings"
          render={() => (
            <RouteView dispatch={dispatch}>
              <Setting name="System Configuration" />
            </RouteView>
          )} />
        <Route
          path="/system_master"
          render={() => (
            <RouteView dispatch={dispatch}>
              <SystemMaster name="System Master" />
            </RouteView>
          )} />
        <Route
          path="/event_logs"
          render={() => (
            <RouteView dispatch={dispatch}>
              <EventLogs name="EventLogs" />
            </RouteView>
          )} />
      </Switch>
    </ConnectedRouter>

)}
export default withRouter(ContentRoutes);
